import { useQuery } from '@tanstack/react-query';
import statusApiFunctions from '../api/status';
import { Queries } from '../types/queries';
import { QueueStatusCheckModel } from '../types/queueStatus';
import { useEffect } from 'react';

const useQueueStatusData = (callback: Function) => {
  const { data, isLoading, isError, refetch } = useQuery<Array<QueueStatusCheckModel>>({
    queryKey: Object.values(Queries.QueueStatusList),
    queryFn: async () => await statusApiFunctions.getQueueStatuses(),
    refetchInterval: 300000, //5 min refresh
  });

  useEffect(() => callback(data), [data]);

  return { data, isLoading, isError, refetch };
};

export default useQueueStatusData;
